import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthenticationService, ReturnUrlService } from '@services';

export const authenticationGuard: CanActivateFn | CanActivateChildFn = (
  _route,
  state
) => {
  if (inject(AuthenticationService).isUserLoggedIn) return true;
  inject(ReturnUrlService).save(state.url);
  return inject(Router).createUrlTree(['/auth/sign-in']);
};
